var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1835 19.8596C16.4819 21.2002 14.3343 22 12 22C9.66564 22 7.51809 21.2001 5.81647 19.8595C6.69114 16.3466 9.25855 14 12 14C14.7414 14 17.3088 16.3466 18.1835 19.8596ZM19.0138 19.1279C18.1978 16.4064 16.4229 14.283 14.2117 13.4198C15.5779 12.6474 16.5 11.1814 16.5 9.5C16.5 7.01472 14.4853 5 12 5C9.5147 5 7.49998 7.01472 7.49998 9.5C7.49998 11.1814 8.4221 12.6474 9.78821 13.4198C7.57707 14.283 5.80218 16.4064 4.9862 19.1279C3.14293 17.3139 2 14.7904 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.7905 20.8571 17.314 19.0138 19.1279ZM19.1987 20.3176C21.5271 18.3007 23 15.3223 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 15.2803 2.43587 18.2253 4.71338 20.2406C4.97322 20.4706 5.24402 20.6884 5.5249 20.8932C5.55176 20.9128 5.57871 20.9323 5.60575 20.9517C7.40771 22.2411 9.61523 23 12 23C14.3848 23 16.5923 22.2411 18.3942 20.9517C18.6723 20.7527 18.9407 20.5411 19.1987 20.3176ZM15.5 9.5C15.5 11.433 13.933 13 12 13C10.067 13 8.49998 11.433 8.49998 9.5C8.49998 7.567 10.067 6 12 6C13.933 6 15.5 7.567 15.5 9.5Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.081c4543bedd52fa0bbe5fab7defef3e.svg";
export { ForwardRef as ReactComponent };